import i18n from "i18next";
import { useQuery, UseQueryResult } from "react-query";

import { IdNamePair } from "@/shared/domain";
import { IDENTITY_STORAGE_KEY } from "@/shared/hooks";

import { getSpApi, requestConfig } from "./apiRoot";
import { StaticTablePath } from "./staticTablePath";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

export const getReference = async (segment: string): Promise<IdNamePair[]> => {
    let accessRightId = undefined;
    if (
        segment === StaticTablePath.Nature ||
        segment === StaticTablePath.Place ||
        segment === StaticTablePath.DamageType
    ) {
        accessRightId = JSON.parse(sessionStorage.getItem(IDENTITY_STORAGE_KEY))?.accessControlListId;
    }
    const axiosRequestConfig = requestConfig({ params: { accessRightId, language: i18n.language } });
    const { data } = await getSpApi().get<IdNamePair[]>(segment, axiosRequestConfig);
    return data;
};

export const getYesNoOptions = (): IdNamePair[] => {
    return [
        { id: "yes", name: i18n.t("Common.Yes") },
        { id: "no", name: i18n.t("Common.No") },
    ];
};

export const useStaticQueryWithStatus = (table: StaticTablePath, enabled = true): UseQueryResult<IdNamePair[]> => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useQuery(table, () => getReference(table), { suspense: false, enabled });
};

export const useStaticQuery = (
    table: StaticTablePath,
    enabled = true,
): {
    options: IdNamePair[];
    loading: boolean;
} => {
    if (table === StaticTablePath.YesNo) return { options: getYesNoOptions(), loading: false };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data = [], isLoading } = useStaticQueryWithStatus(table, enabled);
    return { options: data, loading: isLoading };
};

export const getWindshieldPhonesReference = async (tier: 1 | 2 | 3): Promise<MyBrokerApi.Repairer[]> => {
    const axiosRequestConfig = requestConfig<Paths.ApiReferenceWindshieldrepairers.Get.QueryParameters>({
        params: { windshieldOption: `tier${tier}` },
    });
    const { data } = await getSpApi().get<MyBrokerApi.Repairer[]>(
        UrlManager.referenceWindshieldPhones(),
        axiosRequestConfig,
    );
    return data;
};
